import React, {useState} from 'react'
import './nav.css'
import {AiFillHome} from 'react-icons/ai'
import {FaUserAlt} from 'react-icons/fa'
import {MdOutlineMiscellaneousServices} from 'react-icons/md'
import {BsJournalBookmarkFill} from 'react-icons/bs'
import {MdPermContactCalendar} from 'react-icons/md'


const Nav = () => {
  const [activeNav, setActiveNav] = useState('#')
  return (
    <nav>
      <a href="#" onClick={()=> setActiveNav('#')} className={activeNav==='#'? 'active':''}><AiFillHome/></a>
      <a href="#about" onClick={()=> setActiveNav('#about')} className={activeNav==='#about'? 'active':''}><FaUserAlt/></a>
      <a href="#experience" onClick={()=> setActiveNav('#experience')} className={activeNav==='#experience'? 'active':''}><MdOutlineMiscellaneousServices/></a>
      <a href="#projects" onClick={()=> setActiveNav('#projects')} className={activeNav==='#projects'? 'active':''}><BsJournalBookmarkFill/></a>
      <a href="#contact" onClick={()=> setActiveNav('#contact')} className={activeNav==='#contact'? 'active':''}><MdPermContactCalendar/></a>

    </nav>
  )
}

export default Nav